import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { updateFirmaInspector } from '../../../../redux/DucksUnidadInspeccion/InspectoresDuck';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

const styleModalConfirmacion = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
    p: 4, fontSize: '20px', textAlign: 'center'
};

function ConfiguracionFirma(props) {

    const dispatch = useDispatch()

    let idinspector = props.idinspector;
    const currentUser = useSelector(store => store.Usuario.data)

    const [image, setImage] = React.useState(null);
    const [imageURL, setImageURL] = React.useState(null);
    const [openModalConfirmarValidacion, setOpenModalConfirmarValidacion] = React.useState(false);
    const [openModalConfirmarError, setOpenModalConfirmarError] = React.useState(false);

    const handleImagenSeleccionada = (event) => {
        const archivo = event.target.files[0];

        if (archivo && archivo.type === 'image/png') {
            // Aquí puedes realizar la lógica para subir el archivo, ya que es una imagen PNG.
            console.log('Archivo PNG seleccionado:', archivo.name);
            let lector = new FileReader();
            lector.onload = () => {
                setImageURL(lector.result);
            }
            lector.readAsDataURL(archivo);
            setImage(archivo)
        } else {
            alert('Por favor, selecciona un archivo con extensión .png');
        }
    };

    const guardarFirma = () => {
        if (image != null) {
            const data = {
                idinspector: idinspector,
                image: image
            }
            dispatch(updateFirmaInspector(data))
            handleCloseModalConfirmarValidacion()
            props.cerrar();
        } else {
            console.log("error")
        }
    }

    const handleOpenModalConfirmarValidacion = () => {
        setOpenModalConfirmarValidacion(true);
    }

    const handleCloseModalConfirmarValidacion = () => {
        setOpenModalConfirmarValidacion(false);
    }

    const handleOpenModalConfirmarError = () => {
        setOpenModalConfirmarError(true);
    }

    const handleCloseModalConfirmarError = () => {
        setOpenModalConfirmarError(false);
    }

    const confirmarGuardarFirma = () => {
        return (
            <Modal
                open={openModalConfirmarValidacion}
                onClose={handleCloseModalConfirmarValidacion}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h3>Guardar Firma</h3>
                    ¿Estás seguro de querer guardar esta firma?<br></br>
                    <br />
                    <button onClick={guardarFirma} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }

    const confirmarError = () => {
        return (
            <Modal
                open={openModalConfirmarError}
                onClose={handleCloseModalConfirmarError}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h3>ERROR</h3>
                    Debe seleccionar una imagen en formato PNG<br></br>
                    <br />
                    <button onClick={handleCloseModalConfirmarError} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }

    return (
        <Fragment>
            <h4>Subir Firma Gerencial</h4>
            <h6>Esta firma será la que aparecerá en los formatos generados a nombre de Gerencia de Unidad de Inspección</h6>
            <br />
            <br />
            <h6 style={{ color: "red" }}>(La firma debe ser en formato PNG sin fondo)</h6>
            <br />
            <div style={{ textAlign: "center", width: "50%", margin: "0 auto" }}>
                <input className="form-control" type="file" onChange={handleImagenSeleccionada} accept=".png" />
                <br />
                <br />
                {imageURL && <img src={imageURL} style={{ height: "200px" }} alt="Imagen seleccionada" />}
                <br />
                <br />
                <button className='btn btn-success' onClick={image != null ? handleOpenModalConfirmarValidacion : handleOpenModalConfirmarError}>GUARDAR</button>
            </div>
            {confirmarGuardarFirma()}
            {confirmarError()}
        </Fragment>

    );
}

export default withRouter(ConfiguracionFirma)
